import type { useResponsiveChatOpen } from "@hooks/useResponsiveChatOpen";
import { buildEtfOverlapChatMessage } from "./buildEtfOverlapChatMessage";
import { setPendingOverlapContext } from "./overlapChatContext";

export interface OpenOverlapChatOptions {
  /** 从 Brief 卡发起时，Chat 的返回落点回 Brief */
  returnToBrief?: boolean;
}

type OpenResponsiveChat = ReturnType<
  typeof useResponsiveChatOpen
>["openResponsiveChat"];

/**
 * 「连券商 / 连账户成功 → 回 Chat」的统一打开方式。
 *
 * `autoSubmit:false`：协议行只作为延迟交接的 key 放进 Chat，由 `SyncHandoff` 等持仓同步完成
 * （或用户点 Continue）后再真正发出；这里不能直接发，刚绑定完持仓往往还没同步好。
 *
 * 上传成功路径**不**走本函数：上传带 `attachments`，在 `PlaidConnectFlowModal` 里直接 `autoSubmit:true` 发。
 */
export const openOverlapChatAfterConnect = async (
  openResponsiveChat: OpenResponsiveChat,
  options: OpenOverlapChatOptions = {},
): Promise<void> => {
  // 连接成功后的结果：输入来自 Plaid（入口来源由发起处另行记录）
  setPendingOverlapContext({ input_source: "plaid" });
  await openResponsiveChat({
    question: buildEtfOverlapChatMessage(),
    autoSubmit: false,
    customParams: { source: "etf_overlap_connect" },
    ...(options.returnToBrief ? { returnToBrief: true } : {}),
  });
};
